import {Observable} from 'rxjs/Observable';
import {AjaxFactory, HttpMethod} from '../../_libs/redux-observable-list';
import {AbstractEpics} from '../../core-utilities/redux/AbstractEpics';
import {epicErrorHandler, errorHandler} from '../../core-utilities/rx-utils';
import {CLIENT_VERSION} from '../../config/constants';
import {BASE_REDUX_LIST_OPTIONS} from '../../config/redux-list';
import {pingServerSuccess} from '../../settings/actions';
import {firebaseAuthSuccess} from '../actions';
import {logger} from './logger';

/**
 * Exported for unit testing
 */
export class UserLogAppInfoEpics extends AbstractEpics {
  /**
   * @param options
   */
  constructor(options) {
    super(options);

    this.requestFactory = options.requestFactory;

    this.onSendRequest = this.onSendRequest.bind(this);
    this.addEpic(this.onSendRequest);

    this.onSendRequest.$inject = [
      'DeviceServices',
    ];
  }

  /**
   * @param {ActionsObservable<ReduxAction>} action$
   * @param {Store} store
   * @param dependencies
   */
  onSendRequest(action$, store, dependencies) {
    return Observable
      .combineLatest(
        action$.ofType(firebaseAuthSuccess.TYPE)
          .map(action => action.payload.userId)
          .filter(id => !!id),
        action$.ofType(pingServerSuccess.TYPE),
      )
      .take(1)
      .switchMap(() => {
        const rootState = store.getState();
        const request = {
          device: dependencies.DeviceServices.getBuildAwareDeviceType(),
          deviceVersion: dependencies.DeviceServices.getDeviceVersion(),
          clientVersion: CLIENT_VERSION,
          ua: dependencies.DeviceServices.getUserAgent(),
        };

        return this.requestFactory.sendRequest(request, rootState)
          .catch(errorHandler(this.logger, 'onSendRequest', null, /* maxAttempts=*/ 20, /* multiplier=*/ 5000))
          .mergeMap(() =>  Observable.empty());
      })
      .catch(epicErrorHandler(this.logger, 'UserLogAppInfoEpics.onSendRequest'));
  }
}

function buildAjaxFactory(options) {
  return new AjaxFactory({
    crossDomain: options.crossDomain,
    method: HttpMethod.POST,
    useBody: true,
    url: `${options.baseApiUrl}/users/app-info`,
    getToken: options.getToken,
    responseType: request => 'json',
  });
}

const userLogAppInfoEpics = new UserLogAppInfoEpics({
  logger,
  requestFactory: buildAjaxFactory({
    ...BASE_REDUX_LIST_OPTIONS,
  }),
});

export const epics = userLogAppInfoEpics.epics;



// WEBPACK FOOTER //
// ./src/js/auth/epics/userLogAppInfo.js